<div class="analysis-page-skeleton" data-cy="analysis-page-skeleton">
  <div class="analysis-page-skeleton__header">
    <p-skeleton shape="circle" size="3rem"></p-skeleton>
    <div class="analysis-page-skeleton__header-text">
      <p-skeleton width="18rem" height="1.75rem"></p-skeleton>
      <p-skeleton width="12rem" height="0.875rem"></p-skeleton>
    </div>
  </div>

  <div class="analysis-page-skeleton__summary">
    <p-skeleton height="10rem" borderRadius="1rem"></p-skeleton>
    <p-skeleton height="10rem" borderRadius="1rem"></p-skeleton>
  </div>

  <p-skeleton height="18rem" borderRadius="1rem"></p-skeleton>

  <p-skeleton
    *ngFor="let placeholder of [1, 2, 3]"
    height="4.5rem"
    borderRadius="1rem"></p-skeleton>
</div>
